/**
 * Decide qué restaurante debe quedar como `currentRestaurant` tras cargar la
 * lista de restaurantes del usuario y leer el último seleccionado del storage.
 *
 * Reglas (fuente de verdad para login multi-tenant):
 *  1. Si hay una selección guardada y sigue siendo válida (existe en la lista)
 *     → usar esa.
 *  2. Si hay exactamente 1 restaurante → auto-seleccionarlo.
 *  3. Si hay 2+ y no hay selección válida → devolver `null` para que el
 *     middleware mande al picker `/elegir-restaurante`.
 *  4. Si la lista está vacía → devolver `null`.
 *
 * El bug histórico que arregla: `loadCurrentRestaurantFromStorage` auto-picaba
 * el primer restaurante por orden alfabético cuando había 2+ y la selección
 * guardada no existía. Eso saltaba la pantalla `elegir-restaurante` y dejaba
 * al dueño atrapado en el local equivocado.
 */
export function pickCurrentRestaurant(
  loaded: ReadonlyArray<{ id: string }>,
  savedId: string | null
): string | null {
  if (savedId && loaded.some(r => r.id === savedId)) {
    return savedId
  }
  if (loaded.length === 1) {
    return loaded[0].id
  }
  return null
}
